import { render, staticRenderFns } from "./microList.vue?vue&type=template&id=52e5da1b&scoped=true&"
import script from "./microList.vue?vue&type=script&lang=js&"
export * from "./microList.vue?vue&type=script&lang=js&"
import style0 from "./microList.vue?vue&type=style&index=0&id=52e5da1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5da1b",
  null
  
)

export default component.exports